﻿{
  "version": 1,
  "gameId": "noghte-khat",
  "economy": { "offlineEntryCoins": 0, "offlineWinCoins": 0, "offlineWinXp": 20, "offlineLossXp": 0, "onlineEntryCoins": 0, "onlineWinCoins": 0, "onlineWinXp": 0, "onlineLossXp": 0, "hintCoins": 10 },
  "tutorial": {
    "view": "rules",
    "navigationLabelKey": "noghte-khat.rules.navigationLabel",
    "kickerKey": "noghte-khat.rules.kicker",
    "titleKey": "noghte-khat.rules.title",
    "summaryKey": "noghte-khat.rules.summary",
    "sections": [
      { "id": "setup", "key": "noghte-khat.rules.setup" },
      { "id": "line", "key": "noghte-khat.rules.line" },
      { "id": "box", "key": "noghte-khat.rules.box" },
      { "id": "double", "key": "noghte-khat.rules.double" },
      { "id": "finish", "key": "noghte-khat.rules.finish" },
      { "id": "modes", "key": "noghte-khat.rules.modes" }
    ],
    "settingsAccess": false
  },
  "cosmetics": {}
}
